import gasOperatingPng from 'images/pipelines/gas-operating.png';
import gasPlannedPng from 'images/pipelines/gas-planned.png';
import gasUnderConstructionPng from 'images/pipelines/gas-under-construction.png';
import oilOperatingPng from 'images/pipelines/oil-operating.png';
import oilPlannedPng from 'images/pipelines/oil-planned.png';
import oilUnderConstructionPng from 'images/pipelines/oil-under-construction.png';
import productOperatingPng from 'images/pipelines/product-operating.png';
import productPlannedPng from 'images/pipelines/product-planned.png';
import productUnderConstructionPng from 'images/pipelines/product-under-construction.png';
import unknownOperatingPng from 'images/pipelines/unknown-operating.png';
import unknownPlannedPng from 'images/pipelines/unknown-planned.png';
import unknownUnderConstructionPng from 'images/pipelines/unknown-under-construction.png';

export const addPipelineImages = (map: mapboxgl.Map) => {
  const patterns = [
    { id: 'gas-operating', url: gasOperatingPng },
    { id: 'gas-construction', url: gasUnderConstructionPng },
    { id: 'gas-planned', url: gasPlannedPng },
    { id: 'oil-operating', url: oilOperatingPng },
    { id: 'oil-construction', url: oilUnderConstructionPng },
    { id: 'oil-planned', url: oilPlannedPng },
    { id: 'product-operating', url: productOperatingPng },
    { id: 'product-construction', url: productUnderConstructionPng },
    { id: 'product-planned', url: productPlannedPng },
    { id: 'unknown-operating', url: unknownOperatingPng },
    { id: 'unknown-construction', url: unknownUnderConstructionPng },
    { id: 'unknown-planned', url: unknownPlannedPng },
  ];

  patterns.forEach(({ id, url }) => {
    if (map.hasImage(id)) return;
    map.loadImage(url, (error, image) => {
      if (error) {
        console.error(`Failed to load ${id}:`, error);
        return;
      }
      if (!image) return;
      if (!map.hasImage(id)) {
        map.addImage(id, image);
      }
    });
  });
};
